/**
 * Représente les champs du formulaire de filtrage de trajets
 */
export class FormulaireFiltrageTrajets {
	afficherTrajetsPasses: boolean;
	statutsTrajet: string[];
	lieuxDepart: string[];
	lieuxArrivee: string[];
	heureDepart: string | null;
	heureArrivee: string | null;
	maximumPlaces: number | null;
	minimumPlaces: number | null;

	constructor(
		afficherTrajetsPasses: boolean = false,
		statutsTrajet: string[] = [],
		lieuxDepart: string[] = [],
		lieuxArrivee: string[] = [],
		heureDepart: string | null = null,
		heureArrivee: string | null = null,
		maximumPlaces: number | null = null,
		minimumPlaces: number | null = null
	) {
		this.afficherTrajetsPasses = afficherTrajetsPasses;
		this.statutsTrajet = statutsTrajet;
		this.lieuxDepart = lieuxDepart;
		this.lieuxArrivee = lieuxArrivee;
		this.heureDepart = heureDepart;
		this.heureArrivee = heureArrivee;
		this.maximumPlaces = maximumPlaces;
		this.minimumPlaces = minimumPlaces;
	}

	/**
	 * Vérifie si des filtres sont actifs dans le formulaire.
	 *
	 * @returns {boolean} True si des filtres sont actifs, false sinon.
	 */
	sontFiltresActifs(): boolean {
		return (
			this.afficherTrajetsPasses === true ||
			(this.statutsTrajet && this.statutsTrajet.length > 0) ||
			this.lieuxDepart.length > 0 ||
			this.lieuxArrivee.length > 0 ||
			this.heureDepart !== null ||
			this.heureArrivee !== null ||
			this.maximumPlaces !== null ||
			this.minimumPlaces !== null
		);
	}
}